import React, { useState } from 'react'
import Select from 'react-select'
import axios from 'axios'
import {
  FormInput,
  FormInputDate,
  FormInputText,
  FormInputTextArea,
  Col,
  ContentSectionBlock,
  Button,
  ButtonContainer,
  FormInputSelect,
  Spinner,
  Alert
} from 'camino-react'
import {
  get,
  sortBy,
  find
} from 'lodash'

const Form = ({
  closeForm,
  usersOptions,
  formableTask,
  updateTaskField,
  action,
  submitForm,
  loading,
  buttonDisabled,
  alert
}) => {
  return (
    <ContentSectionBlock title={`${action === 'edit' ? 'Edit' : 'New'} Task`} actions={[{ onClick: () => closeForm(), text: 'X' }]}>
      {alert.type && (
        <Alert type={alert.type}>
          {alert.text}
        </Alert>
      )}
      <FormInput label="Title">
        <FormInputText
          value={get(formableTask, 'name')}
          onValue={value => updateTaskField('name', value)}
        />
      </FormInput>

      <FormInput label="Description">
        <FormInputTextArea
          onValue={value => updateTaskField('description', value)}
          value={get(formableTask, 'description')}
        />
      </FormInput>

      <FormInput label="Assignee">
        <FormInputSelect
          options={sortBy(usersOptions, 'label')}
          value={find(usersOptions, ['value', get(formableTask, 'assignee_id')])}
          onValue={value => updateTaskField('assignee_id', value)}
        />
      </FormInput>

      <div className="row row--bottom-spaced">
        <Col>
          <FormInput label="Start date">
            <FormInputDate
              enableTime
              value={get(formableTask, 'start_at')}
              onValue={value => updateTaskField('start_at', value)}
            />
          </FormInput>
        </Col>
        <Col>
          <FormInput label="End date">
            <FormInputDate
              enableTime
              value={get(formableTask, 'due_at')}
              onValue={value => updateTaskField('due_at', value)}
            />
          </FormInput>
        </Col>
      </div>

      <ButtonContainer>
        <Button disabled={buttonDisabled} onClick={() => submitForm()}>
          Save &nbsp;
          {loading && (<Spinner />)}
        </Button>
      </ButtonContainer>
    </ContentSectionBlock>
  )
}

export default Form
